/* tslint:disable */
/* eslint-disable */


export class BaseClass {
  protected bearerToken: string;

  static accessTokenProvider: any;

  static configure(accessTokenProvider: any) {
    BaseClass.accessTokenProvider = accessTokenProvider;
  }

  async getAccessToken() {
    if (!BaseClass.accessTokenProvider) {
      throw new Error('Authentication is not configured. Please call BaseClass.configure() first.');
    }

    try {
      const token = await BaseClass.accessTokenProvider();

      return token;
    } catch (error) {
      console.error('Error getting access token:', error);
      throw error;
    }
  }

  constructor(bearerToken?: string) {

    this.bearerToken = bearerToken !== undefined && bearerToken !== null ? bearerToken : "";
  }

  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.getAccessToken();

    options.headers = {
      ...options.headers,
      Authorization: 'Bearer ' + token,
    };
    options.credentials = 'include';
    return Promise.resolve(options);
  };
}
